<template>
  <div>
    <div class="mb-4 bg-indigo-900 py-6">
        <inertia-link class="flex items-center group" href="/">
            <logo class="fill-white" height="100" />
        </inertia-link>
    </div>
    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
      </inertia-link>
    </div>

    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('settings')">
        <icon name="settings" class="w-4 h-4 mr-2" :class="isUrl('settings') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('settings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Settings</div>
      </inertia-link>
    </div>

    <div v-if="$posthog.isFeatureEnabled('automod-tab')" class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('automod')">
        <icon name="automod" class="w-4 h-4 mr-2" :class="isUrl('automod') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('automod') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Automoderation</div>
      </inertia-link>
    </div>

    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('notification')">
        <icon name="discord" class="w-4 h-4 mr-2" :class="isUrl('notification') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('notification') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Notification</div>
      </inertia-link>
    </div>
  
    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('commands')">
        <icon name="commands" class="w-4 h-4 mr-2" :class="isUrl('commands') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('commands') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Commands</div>
      </inertia-link>
    </div>

    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('quotes')">
        <icon name="quotes" class="w-4 h-4 mr-2" :class="isUrl('quotes') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('quotes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Quotes</div>
      </inertia-link>
    </div>

    <div v-if="$posthog.isFeatureEnabled('reactions-tab')" class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('reactions')">
        <icon name="reactions" class="w-4 h-4 mr-2" :class="isUrl('reactions') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reactions') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reactions</div>
      </inertia-link>
    </div>
  

    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('announcements')">
        <icon name="announcements" class="w-4 h-4 mr-2" :class="isUrl('announcements') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('announcements') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Announcements</div>
      </inertia-link>
    </div>

    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('anniversaries')">
        <icon name="sub_anni" class="w-4 h-4 mr-2" :class="isUrl('anniversaries') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('anniversaries') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Sub Anniversaries</div>
      </inertia-link>
    </div>

    <div class="mb-4 px-6">
      <a class="flex items-center group py-3" :href="route('modview')" target="_blank">
        <icon name="preview" class="w-4 h-4 mr-2" :class="isUrl('modview') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('modview') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Mod View</div>
      </a>
    </div>

    <!--
    <div class="mb-4 px-6">
      <inertia-link class="flex items-center group py-3" :href="route('shortener')">
        <icon name="shortener" class="w-4 h-4 mr-2" :class="isUrl('shortener') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('viewer') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Link Shortener</div>
      </inertia-link>
    </div>
  -->

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'

export default {
  components: {
    Icon,
    Logo,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
